import { trim } from "lodash";

/**
 * Classify a suggest_standardized_address response into a save branch.
 * Mirrors BusinessSettings' OfficeCards.onAddEditAddressSubmit branching.
 *
 * @param {Object} res - axios response from getSuggestedAddressCheck
 * @returns {{ type: "standardized" }
 *   | { type: "invalid" }
 *   | { type: "verify", suggestedAddress: Object }}
 */
export const classifyStandardizedAddress = (res) => {
  const details = res?.data?.addressDetails;

  if (details?.standardized) {
    return { type: "standardized" };
  }

  if (trim(details?.streetAddress ?? "") === "") {
    return { type: "invalid" };
  }

  return {
    type: "verify",
    suggestedAddress: {
      streetAddress: details.streetAddress,
      secondaryAddress: details.secondaryAddress,
      city: details.city,
      locality: details.locality,
      postalCode: details.postalCode,
      country: details.country,
    },
  };
};

export default classifyStandardizedAddress;
